import { render } from "./InnovationComment.vue?vue&type=template&id=51954ae7"
import script from "./InnovationComment.vue?vue&type=script&lang=js"
export * from "./InnovationComment.vue?vue&type=script&lang=js"
script.render = render

export default script